 $(document).ready(function() {

  // section collection edito
  var lastScrollTop = 0;
  $(window).on("scroll", function() {
    var scrollTop = $(this).scrollTop();
    if (scrollTop < lastScrollTop) {
        $(".edito").css("top", "54px");
    } else {
        $(".edito").css("top", "0");
    }
    lastScrollTop = scrollTop;
  });

   // Changement de langue
   $(document).on("click", '#FooterLanguageForm span', function () {
      $(this).siblings('input[name=locale_code]').val($(this).data("value"));
      $(this).parent().submit();
   });

   // Apparition échantillons gratuits panier tiroir
    $(document).on('click', '.samples_grid.samples h2', function(){
      $(this).toggleClass("opened");
      $(this).next(".slider-component-desktop").slideToggle();
   });

      /// Section principale
   $(document).on("click", '.section-main, .section-image-text img', function () {
      $(this).next("div").find("a")[0].click();
   });

    $(".section-main, .section-image-text img").hover(function(e) {
      var redirect = $(this).next("div").find("a")[0];

      if (redirect != undefined) {
         $(this).css("cursor", "pointer");
      }
   });

   $(document).on('click', '.section-medias .column', function(){
    var redirect = $(this).find("a").attr("href");
    if (redirect) {
      window.location.href = redirect;
    }
  });

    // Popin search
    var header_height = $(".header-wrapper").height();
     $(".search-modal.modal__content").css("top", header_height + "px");


   // Boutiques
   // Slider images
   $('.slider_store').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: '.slider_nav'
   });

   $('.slider_nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      asNavFor: '.slider_store',
      focusOnSelect: true
   });

   // PDV
   $(".country").each(function() {
      var country = $(this).attr("id");
      var country_name = $(this).html();
      $(".pdv_page nav.pdv").append("<a href=#" + country.toLowerCase() +  ">" + country_name + "</a>");
   });

   // FAQ
   $(".faq_theme").each(function() {
      var faq = $(this).attr("id");
      var faq_name = $(this).html();
      $(".faq_page nav.faq").append("<a href=#" + faq.toLowerCase() +  ">" + faq_name + "</a>");
   });

   $(document).on("click", '.faq_list h3', function () {
      var questions = $(".faq_list h3");
      var answers = $(".faq_list > div");
      $(this).toggleClass("opened");
      if (answers.length) {
         $(questions).not($(this)).removeClass("opened");
         $(questions).not($(this)).next(answers).slideUp();
         $(this).next("div").slideToggle();
      }
   });

   // Filtres page collection version mobile
   $(".mobile-facets__details:first-child .mobile-facets__summary").addClass("opened");

   $(document).on("click", '.mobile-facets__summary', function () {
      var filter = $(".mobile-facets__summary");
      var value = $(".mobile-facets__details > .mobile-facets__submenu");
      $(this).toggleClass("opened");
      if (value.length) {
         $(filter).not($(this)).removeClass("opened");
         $(filter).not($(this)).next(value).slideUp();
         $(this).next("div").slideToggle();
      }
   });

   $(document).on("click", '.samples-card-drawer-cart', function () {
      $(this).find("button")[0].click();
   });

   // PLP load more
   // Load more
  $(document).on("click", '.js-load-more', function () {
    var $this = $(this), totalPages = parseInt($('[data-total-pages]').val()), currentPage = parseInt($('[data-current-page]').val());
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    currentPage = currentPage + 1;
    var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
    $('[data-current-page]').val(currentPage);
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function (responseHTML) {
        $('#product-grid').append($(responseHTML).find('#product-grid').html());
        $('.blog-articles').append($(responseHTML).find('.blog-articles').html());
      },
      complete: function () {
        if (currentPage <= totalPages) {
          $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
        }
        if (currentPage == totalPages) {
          $this.hide();
        }
      }
    })
  });

   // Page produit bundle
   if ($("#product_bundle").length) {

    $("#product_bundle select.select__select").each(function() {
        var value = $(this).find("option:selected").data("barcode");
        $(this).next().val(value);
    });

    $("#product_bundle select.select__select").on("change", function() {
      var value = $(this).find("option:selected").data("barcode");
      $(this).next().val(value);
    });
   }

   // Page produit Accordeons
   $(".tabs h2:first-child").addClass("opened");

   $(".tabs h2").click(function(e) {
      var title = $(".tabs h2");
      var content = $(".tabs > div");
      $(this).toggleClass("opened");
      if (content.length) {
         $(title).not($(this)).removeClass("opened");
         $(title).not($(this)).next(content).slideUp();
         $(this).next("div").slideToggle();
      }
   });

   $(document).on("click", '.product__info-container .see_more', function () {
      $(".product__description").toggleClass("extend");
    });

   // Article
   // Au clic sur .see more, on toggle la class extend au div .article-template__content
    $(document).on("click", '.article-template__content .see_more', function () {
      $(".article-template__content").toggleClass("extend");
    });

});
